module.exports = __webpack_public_path__ + "img/bg_ellipse_02.32d9235.png";